//import action types
import { CREATE_BOARD, UPDATE_BOARD, GET_ALL_BOARDS, DELETE_BOARD, SHARED_BOARD_EMAILS } from "../actions/types";

const initialState = []

const boardsReducer = (boards = initialState, action) => {
    const { type, payload } = action
    switch(type) {
      case CREATE_BOARD:
        return [...boards, payload[0]];

      case GET_ALL_BOARDS:
        return payload;

      case UPDATE_BOARD:
        return boards.map((board) => {
          if (board.id === payload[0].id) {
            return {
              ...board,
              name: payload[0].name,
            };
          } else {
            return board;
          }
        });
  
      case DELETE_BOARD:
        return boards.filter(({ id }) => id !== payload.id);

      default:
        return boards;
    }
}

const boardsEmailReducer = (emails = initialState, action) => {
  const { type, payload } = action
  switch(type) {

    case SHARED_BOARD_EMAILS:
      return payload;

    default:
      return emails;
  }
}

const boardReducer = {
  boardsReducer, 
  boardsEmailReducer
}

export default boardReducer;